import { createSlice } from "@reduxjs/toolkit";
import { backhandTypeOptions, surfaceOptions } from "../constants/reportGenerationOptions";

const initialReportGenerationInputs = {
    stdReportInputs: {
        category: null,
        selectedTargetPlayers: [],
        selectedOpponentPlayers: [],
        selectedTournaments: [],
        opponent: 0,
        fromYear: new Date().getFullYear(),
        toYear: new Date().getFullYear(),
        targetSpeedUnit: "KMH",
        isHardSelected: true,
        isClaySelected: true,
        isGrassSelected: true,
        isCarpetSelected: true,
        withRets: false,
        backhandType: backhandTypeOptions[0].value,
        useHEData: 2,
        gameResultSelection: 2,
        gameServeSelection: 2,
        includeTieBreakGames: true,
    },
};

const reportGenerationSlice = createSlice({
    name: "reportGeneration",
    initialState: initialReportGenerationInputs,
    reducers: {
        setStdReportInputs(state, action) {
            state.stdReportInputs = action.payload;
        },
    },
});

export const {
    setStdReportInputs,
    setSelectedSurfaces
} = reportGenerationSlice.actions;

export const selectStdReportInputs = (state) => state.reportGeneration.stdReportInputs;
export default reportGenerationSlice.reducer;
